import React, { useState } from "react";
import { Link } from "react-router-dom";

/* ------------------------------------------------------------------
   IMAGE PATHS  (files live in  src/assets/images/ )
   Put your picture in that folder with the SAME file name below.
   If it is missing the page still works (navy background shows).
------------------------------------------------------------------- */
const imageFiles = require.context("../assets/images", false, /\.(png|jpe?g|webp|svg)$/);
const pic = (name) => {
  try { return imageFiles(`./${name}`); } catch (e) { return undefined; }
};
const images = {
  banner: pic("contact-banner.jpg"), // 1920 x 500
};
const bg = (overlay, img) => (img ? `${overlay}, url(${img})` : overlay);

/* ------------------------------------------------------------------
   FORM EMAIL SETTINGS
   Option A (free, recommended): create an account at emailjs.com, then paste
   your three values below. Messages will arrive in your Gmail.
   Option B: leave them empty. Then "Send Message" opens Gmail (new tab) with
   everything filled in, addressed to COMPANY_EMAIL (the visitor must press send).
------------------------------------------------------------------- */
const EMAILJS_SERVICE_ID = "";   // e.g. "service_abc123"
const EMAILJS_TEMPLATE_ID = "";  // e.g. "template_xyz789"
const EMAILJS_PUBLIC_KEY = "";   // e.g. "AbCdEfGhIjKl"
const COMPANY_EMAIL = "guardianfacilityservicesltd@gmail.com";
const MAP_QUERY = "78 Compton Avenue E6 3DP";

/* ------------------------------------------------------------------
   ICONS (inline SVG, no extra packages needed)
------------------------------------------------------------------- */
const paths = {
  pin: (<><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></>),
  phone: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />,
  mail: (<><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" /></>),
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  send: <path d="M22 2 11 13M22 2l-7 20-4-9-9-4z" />,
  home: <path d="M3 11l9-8 9 8M5 10v10h14V10M10 20v-6h4v6" />,
  building: (<><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2M10 21v-3h4v3" /></>),
  key: (<><circle cx="7.5" cy="15.5" r="4.5" /><path d="M10.8 12.2 21 2M17 6l3 3M14 9l2.5 2.5" /></>),
  wrench: <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />,
  sparkles: (<><path d="M11 3l1.9 5.1L18 10l-5.1 1.9L11 17l-1.9-5.1L4 10l5.1-1.9z" /><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" /></>),
  check: <path d="M5 12.5l4.5 4.5L19 7" />,
  checkCircle: (<><circle cx="12" cy="12" r="9" /><path d="M8 12.5l3 3 5-6" /></>),
  alert: (<><circle cx="12" cy="12" r="9" /><path d="M12 7.5v5M12 16h.01" /></>),
};

function Icon({ name, size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  );
}

/* ------------------------------------------------------------------
   PAGE CONTENT
------------------------------------------------------------------- */
const propertyTypes = [
  { value: "Residential", icon: "home" },
  { value: "Commercial", icon: "building" },
];

const serviceOptions = [
  { value: "Property Renting/Lettings", icon: "key" },
  { value: "Maintenance & Repairs", icon: "wrench" },
  { value: "Professional Cleaning", icon: "sparkles" },
];

const initial = {
  name: "", email: "", phone: "", propertyType: "", services: [], message: "", website: "",
};

/* ------------------------------------------------------------------
   PAGE CSS (everything for the Contact page is in this file)
------------------------------------------------------------------- */
const css = `
.ct-banner{background-color:var(--navy-deep);background-size:cover;background-position:center;color:#fff;padding-top:90px;padding-bottom:150px}
.ct-banner-inner{max-width:720px;animation:ctRise .8s ease-out both}
@keyframes ctRise{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:none}}
.ct-banner h1{color:#fff;font-size:clamp(32px,4.8vw,52px);font-weight:800;letter-spacing:-.5px;margin-bottom:16px}
.ct-banner p{font-size:20px;font-style:italic;color:#DCE3EA;margin:0;max-width:620px}

.ct-main{position:relative;z-index:2;margin-top:-90px;padding-bottom:90px}
.ct-grid{display:grid;grid-template-columns:.8fr 1.2fr;gap:32px;align-items:start}

.ct-info{background:var(--navy);color:#fff;border-radius:6px;padding:40px 34px;border-top:4px solid var(--gold);box-shadow:0 18px 40px rgba(15,34,56,.18)}
.ct-info h2{color:#fff;font-size:26px;margin-bottom:8px}
.ct-info > p{color:#C4CFDA;font-size:16.5px;margin-bottom:28px}
.ct-item{display:flex;gap:16px;padding:18px 0;border-top:1px solid rgba(185,194,204,.22)}
.ct-item-ico{flex:0 0 auto;width:46px;height:46px;border-radius:50%;background:rgba(201,162,75,.16);color:var(--gold);display:grid;place-items:center}
.ct-item small{display:block;color:#9FB0C2;font-size:13.5px;margin-bottom:2px}
.ct-item a,.ct-item span.v{color:#fff;text-decoration:none;font-weight:600;font-size:17px;line-height:1.4;word-break:break-word}
.ct-item a:hover{color:var(--gold)}
.ct-hours{display:grid;gap:2px;font-size:16.5px;font-weight:600;color:#fff}
.ct-hours span{font-weight:400;color:#C4CFDA}

.ct-card{background:#fff;border:1px solid #E1E6EB;border-radius:6px;padding:40px 38px;box-shadow:0 18px 40px rgba(15,34,56,.1)}
.ct-card h2{font-size:28px;margin-bottom:6px}
.ct-card > p{color:var(--muted);margin-bottom:28px}
.ct-row{display:grid;grid-template-columns:1fr 1fr;gap:18px}
.ct-field{margin-bottom:22px}
.ct-label{display:block;font-family:var(--font-head);font-weight:600;font-size:15px;color:var(--navy);margin-bottom:8px}
.ct-input,.ct-textarea{width:100%;font-family:var(--font-body);font-size:17px;color:var(--ink);background:#fff;border:1.5px solid #CBD3DB;border-radius:4px;padding:13px 14px;transition:border-color .2s,box-shadow .2s}
.ct-textarea{min-height:140px;resize:vertical}
.ct-input:focus,.ct-textarea:focus{outline:0;border-color:var(--navy);box-shadow:0 0 0 3px rgba(24,51,80,.14)}
.ct-input[aria-invalid="true"],.ct-textarea[aria-invalid="true"]{border-color:#B3261E}
.ct-err{display:flex;align-items:center;gap:6px;color:#B3261E;font-size:14.5px;margin-top:6px}

.ct-tiles{display:flex;gap:12px;flex-wrap:wrap}
.ct-tile{position:relative;flex:1 1 160px}
.ct-tile input{position:absolute;opacity:0;inset:0;width:100%;height:100%;margin:0;cursor:pointer}
.ct-tile-box{display:flex;align-items:center;gap:12px;padding:14px 16px;border:1.5px solid #CBD3DB;border-radius:4px;font-weight:600;color:var(--navy);font-size:16px;background:#fff;transition:border-color .2s,background .2s,color .2s}
.ct-tile-box .tick{margin-left:auto;width:22px;height:22px;border-radius:50%;border:1.5px solid #CBD3DB;display:grid;place-items:center;color:transparent;flex:0 0 auto}
.ct-tile input:checked + .ct-tile-box{border-color:var(--navy);background:var(--mist)}
.ct-tile input:checked + .ct-tile-box .tick{background:var(--navy);border-color:var(--navy);color:#fff}
.ct-tile input:focus-visible + .ct-tile-box{outline:3px solid var(--gold);outline-offset:2px}
.ct-tile:hover .ct-tile-box{border-color:var(--navy-soft)}

.ct-hp{position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden}
.ct-submit{display:inline-flex;align-items:center;gap:10px;border:0;font-size:16px;padding:15px 32px}
.ct-submit:disabled{opacity:.65;cursor:not-allowed}
.ct-note{margin:18px 0 0;font-size:14.5px;color:var(--muted)}
.ct-note a{color:var(--navy);font-weight:600}
.ct-banner-msg{display:flex;gap:14px;align-items:flex-start;padding:18px 20px;border-radius:4px;margin-bottom:24px;font-size:16.5px}
.ct-banner-msg.ok{background:#EAF5EE;border:1px solid #B8DCC4;color:#1E5B33}
.ct-banner-msg.bad{background:#FCECEA;border:1px solid #F0C2BE;color:#8C1D18}
.ct-banner-msg svg{flex:0 0 auto;margin-top:2px}
.ct-banner-msg strong{display:block;font-family:var(--font-head);margin-bottom:2px}

.ct-map{padding-top:0;padding-bottom:96px}
.ct-map h2{font-size:clamp(26px,3.2vw,34px);font-weight:800;margin-bottom:8px}
.ct-map p{color:var(--muted);margin-bottom:24px;font-size:17.5px}
.ct-map-frame{border:1px solid #E1E6EB;border-radius:6px;overflow:hidden;background:var(--mist)}
.ct-map-frame iframe{display:block;width:100%;height:400px;border:0}

@media (max-width:980px){
  .ct-banner{padding-top:70px;padding-bottom:130px}
  .ct-grid{grid-template-columns:1fr}
  .ct-main{padding-bottom:72px}
  .ct-map{padding-bottom:72px}
}
@media (max-width:560px){
  .ct-card{padding:28px 20px}
  .ct-info{padding:32px 22px}
  .ct-row{grid-template-columns:1fr;gap:0}
  .ct-map-frame iframe{height:320px}
}
`;

/* ------------------------------------------------------------------
   COMPONENT
------------------------------------------------------------------- */
export default function Contact() {
  const [form, setForm] = useState(initial);
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | sending | success | mailto | error

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const toggleService = (value) => {
    const has = form.services.includes(value);
    setForm({ ...form, services: has ? form.services.filter((s) => s !== value) : [...form.services, value] });
  };

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Please enter your full name.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) e.email = "Please enter a valid email address.";
    if (form.phone.replace(/\D/g, "").length < 10) e.phone = "Please enter a valid phone number.";
    if (!form.propertyType) e.propertyType = "Please choose a property type.";
    if (form.services.length === 0) e.services = "Please tick at least one service.";
    if (form.message.trim().length < 10) e.message = "Please tell us a little about what you need.";
    return e;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (form.website) return; // spam trap: real visitors never fill this
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length) return;

    const servicesText = form.services.join(", ");
    setStatus("sending");

    if (EMAILJS_SERVICE_ID && EMAILJS_TEMPLATE_ID && EMAILJS_PUBLIC_KEY) {
      try {
        const res = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            service_id: EMAILJS_SERVICE_ID,
            template_id: EMAILJS_TEMPLATE_ID,
            user_id: EMAILJS_PUBLIC_KEY,
            template_params: {
              from_name: form.name,
              from_email: form.email,
              phone: form.phone,
              property_type: form.propertyType,
              services: servicesText,
              message: form.message,
            },
          }),
        });
        if (!res.ok) throw new Error("send failed");
        setStatus("success");
        setForm(initial);
      } catch (err) {
        setStatus("error");
      }
    } else {
      const body =
        `Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\n` +
        `Property type: ${form.propertyType}\nServices: ${servicesText}\n\n${form.message}`;
      const subject = "Free estimate enquiry from " + form.name;
      const gmailUrl =
        "https://mail.google.com/mail/?view=cm&fs=1" +
        `&to=${encodeURIComponent(COMPANY_EMAIL)}` +
        `&su=${encodeURIComponent(subject)}` +
        `&body=${encodeURIComponent(body)}`;
      window.open(gmailUrl, "_blank", "noopener,noreferrer");
      setStatus("mailto");
    }
  };

  const err = (key) => errors[key] && (
    <div className="ct-err" id={`err-${key}`} role="alert"><Icon name="alert" size={16} />{errors[key]}</div>
  );

  return (
    <>
      <style>{css}</style>

      {/* BANNER */}
      <section
        className="ct-banner"
        style={{ backgroundImage: bg("linear-gradient(90deg, rgba(15,34,56,.93) 0%, rgba(15,34,56,.75) 55%, rgba(15,34,56,.45) 100%)", images.banner) }}
      >
        <div className="container">
          <div className="ct-banner-inner">
            <h1>Get a Free Estimate</h1>
            <p>Reach out today for property renting inquiries, maintenance callouts, or cleaning bookings.</p>
          </div>
        </div>
      </section>

      {/* INFO + FORM */}
      <section className="ct-main">
        <div className="container ct-grid">
          <aside className="ct-info">
            <h2>Direct Contact</h2>
            <p>Prefer to talk? Call, email or visit us using the details below.</p>

            <div className="ct-item">
              <div className="ct-item-ico"><Icon name="pin" /></div>
              <div>
                <small>Office Address</small>
                <span className="v">78 Compton Avenue, E6 3DP</span>
              </div>
            </div>
            <div className="ct-item">
              <div className="ct-item-ico"><Icon name="phone" /></div>
              <div>
                <small>Phone</small>
                <a href="tel:07459262621">07459 262621</a>
              </div>
            </div>
            <div className="ct-item">
              <div className="ct-item-ico"><Icon name="mail" /></div>
              <div>
                <small>Email</small>
                <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${COMPANY_EMAIL}`} target="_blank" rel="noopener noreferrer">{COMPANY_EMAIL}</a>
              </div>
            </div>
            <div className="ct-item">
              <div className="ct-item-ico"><Icon name="clock" /></div>
              <div>
                <small>Opening Hours</small>
                <div className="ct-hours">
                  <div>Monday - Friday: <span>7:30 AM - 8:00 PM</span></div>
                  <div>Saturday: <span>9:00 AM - 5:00 PM</span></div>
                </div>
              </div>
            </div>
          </aside>

          <div className="ct-card">
            <h2>Send Us a Message</h2>
            <p>Tell us about your property and what you need. All fields are required.</p>

            {status === "success" && (
              <div className="ct-banner-msg ok" role="status">
                <Icon name="checkCircle" size={24} />
                <div><strong>Message sent</strong>Thank you. We have received your enquiry and will get back to you soon.</div>
              </div>
            )}
            {status === "mailto" && (
              <div className="ct-banner-msg ok" role="status">
                <Icon name="checkCircle" size={24} />
                <div><strong>Almost done</strong>Gmail has opened in a new tab with your message ready. Press send there to complete your enquiry.</div>
              </div>
            )}
            {status === "error" && (
              <div className="ct-banner-msg bad" role="alert">
                <Icon name="alert" size={24} />
                <div><strong>Something went wrong</strong>Your message could not be sent. Please try again, or call 07459 262621.</div>
              </div>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <div className="ct-row">
                <div className="ct-field">
                  <label className="ct-label" htmlFor="ct-name">Full Name</label>
                  <input id="ct-name" className="ct-input" type="text" autoComplete="name"
                    value={form.name} onChange={set("name")}
                    aria-invalid={!!errors.name} aria-describedby={errors.name ? "err-name" : undefined} />
                  {err("name")}
                </div>
                <div className="ct-field">
                  <label className="ct-label" htmlFor="ct-phone">Phone Number</label>
                  <input id="ct-phone" className="ct-input" type="tel" autoComplete="tel"
                    value={form.phone} onChange={set("phone")}
                    aria-invalid={!!errors.phone} aria-describedby={errors.phone ? "err-phone" : undefined} />
                  {err("phone")}
                </div>
              </div>

              <div className="ct-field">
                <label className="ct-label" htmlFor="ct-email">Email Address</label>
                <input id="ct-email" className="ct-input" type="email" autoComplete="email"
                  value={form.email} onChange={set("email")}
                  aria-invalid={!!errors.email} aria-describedby={errors.email ? "err-email" : undefined} />
                {err("email")}
              </div>

              <fieldset className="ct-field" style={{ border: 0, padding: 0, margin: "0 0 22px" }}>
                <legend className="ct-label">What type of property do you have?</legend>
                <div className="ct-tiles">
                  {propertyTypes.map((p) => (
                    <label className="ct-tile" key={p.value}>
                      <input type="radio" name="propertyType" value={p.value}
                        checked={form.propertyType === p.value} onChange={set("propertyType")} />
                      <span className="ct-tile-box">
                        <Icon name={p.icon} size={22} />{p.value}
                        <span className="tick"><Icon name="check" size={14} /></span>
                      </span>
                    </label>
                  ))}
                </div>
                {err("propertyType")}
              </fieldset>

              <fieldset className="ct-field" style={{ border: 0, padding: 0, margin: "0 0 22px" }}>
                <legend className="ct-label">What services do you need? (Tick all that apply)</legend>
                <div className="ct-tiles">
                  {serviceOptions.map((s) => (
                    <label className="ct-tile" key={s.value}>
                      <input type="checkbox" name="services" value={s.value}
                        checked={form.services.includes(s.value)} onChange={() => toggleService(s.value)} />
                      <span className="ct-tile-box">
                        <Icon name={s.icon} size={22} />{s.value}
                        <span className="tick"><Icon name="check" size={14} /></span>
                      </span>
                    </label>
                  ))}
                </div>
                {err("services")}
              </fieldset>

              <div className="ct-field">
                <label className="ct-label" htmlFor="ct-message">Your Message / Project Details</label>
                <textarea id="ct-message" className="ct-textarea"
                  value={form.message} onChange={set("message")}
                  aria-invalid={!!errors.message} aria-describedby={errors.message ? "err-message" : undefined} />
                {err("message")}
              </div>

              {/* hidden spam trap */}
              <div className="ct-hp" aria-hidden="true">
                <label>Website<input type="text" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} /></label>
              </div>

              <button type="submit" className="btn btn-gold ct-submit" disabled={status === "sending"}>
                {status === "sending" ? "Sending..." : "Send Message"}
                <Icon name="send" size={18} />
              </button>
              <p className="ct-note">
                We only use your details to reply to your enquiry. See our <Link to="/privacy-policy">Privacy Policy</Link>.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* MAP */}
      <section className="ct-map">
        <div className="container">
          <h2>Find Our Office</h2>
          <p>78 Compton Avenue, E6 3DP</p>
          <div className="ct-map-frame">
            <iframe
              title="Guardian Facility Services office location"
              src={`https://www.google.com/maps?q=${encodeURIComponent(MAP_QUERY)}&output=embed`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </>
  );
}